import React from 'react';
import { ResumeAuthorAge, ResumeAuthorName } from '@cp/entities/resume';
import { useTheme } from '@cp/ds/src/hooks/useTheme';
import { Stack } from '@cp/ds/src/components/stack';
import { RoutedLink as Link } from 'src/shared/ui/link';
import { ResumeCardNew as ResumeCardEntity } from 'src/entities/resume/ui/card/ResumeCardNew';
import { ICatalogItem } from 'src/entities/catalog';
import { useClientProfile } from 'src/entities/client';
import { useIsEmbedded } from 'src/shared/mediaQueries';

// Disable lazy load for first items
const EAGER_LOAD_FOR_IDX = 3;

export const ResumeCardWidgetV2 = ({ data, url, index = 0, ...props }: ICatalogItem) => {
  const theme = useTheme();
  const isEmbedded = useIsEmbedded();
  const clientProfile = useClientProfile();

  const handleTitleLinkClick: React.MouseEventHandler<HTMLAnchorElement> = (e) => {
    if (!clientProfile) {
      e.stopPropagation();
    }
  };
  const permalink = url ? String(url) : undefined;

  return (
    <ResumeCardEntity
      data={data}
      header={
        <Link
          external={Boolean(permalink && !isEmbedded)}
          href={permalink}
          onClick={handleTitleLinkClick}
          sx={{ display: 'contents' }}
          underline={false}
        >
          <Stack alignItems="flex-end" direction="row" gap={'2px'}>
            <ResumeAuthorName
              author={data?.clientProfile || {}}
              sx={{ fontSize: { xs: '14px', md: '16px' }, lineHeight: 1.1, fontWeight: 500 }}
            />
            <ResumeAuthorAge age={data?.clientProfile?.age} variant="small text bold" />
          </Stack>
        </Link>
      }
      loadPolicy={index <= EAGER_LOAD_FOR_IDX ? 'eager' : 'lazy'}
      sx={{ backgroundColor: theme.palette.background.default }}
      {...props}
    />
  );
};
